module.exports = __webpack_public_path__ + "static/img/fc.9be7c52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/fc.png
// module id = kPVl
// module chunks = 1